module.exports = __webpack_public_path__ + "img/swap-active.644c7c8e.svg";